import React, { useEffect, useState } from 'react';
import BlankTemplate from 'components/Templates/BlankTemplate';
import InitiatePIP from 'components/Organisms/Employee/EmployeeRecord/ActionList/InitiatePIP';
import { useThunk } from 'hooks/useThunk';
import { fetchInitiatePIP } from 'store';
import { Typography, Box, Skeleton } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { initiateEmployeePIPAction } from 'api/employees';
import dayjs from 'dayjs';
import useToast from 'components/Provider/useToast';

const InitiatePIPPage = () => {
  const addToast = useToast();
  const navigate = useNavigate();
  const { userId } = useParams();

  const [loading, setLoading] = useState(false);
  const [getInitiatePIP, isLoadingInitiatePIP, loadingInitiatePIPError] = useThunk(fetchInitiatePIP);

  useEffect(() => {
    const query = new URLSearchParams({});
    query.append('id', userId);
    getInitiatePIP(query);
  }, [userId, getInitiatePIP]);

  const { initiatePIP } = useSelector((state) => state.employees);

  const employeeData = {
    supervisor: initiatePIP?.employeeInstance?.supervisor?.fullName,
    department: initiatePIP?.employeeInstance?.department?.name,
    designation: initiatePIP?.employeeInstance?.designation?.name,
    location: initiatePIP?.employeeInstance?.location?.name,
  };

  const handleSubmit = async ({ startDate, endDate, notes }) => {
    const newStartDate = startDate ? dayjs(startDate).format('MM/DD/YYYY') : '';
    const newEndDate = endDate ? dayjs(endDate).format('MM/DD/YYYY') : '';
    const bodyFormData = new FormData();
    bodyFormData.append('empID', initiatePIP?.user?.employeeId);
    bodyFormData.append('CurrentAction', 'SaveAndSubmit');
    bodyFormData.append('startDate', newStartDate);
    bodyFormData.append('endDate', newEndDate);
    bodyFormData.append('notes', notes || '');

    try {
      setLoading(true);
      const response = await initiateEmployeePIPAction(bodyFormData);
      if (response?.data?.status === 'SUCCESS') {
        addToast({ type: 'success', title: 'SUCCESS', message: response?.data?.message });
        navigate(`/company/employee/view/${userId}`);
      } else {
        addToast({ type: 'error', title: 'ERROR', message: response?.data?.message });
      }
    } catch (error) {
      addToast({ type: 'error', title: 'ERROR', message: error?.response?.data?.message || error?.message });
    } finally {
      setLoading(false);
    }
  };

  if (loadingInitiatePIPError !== null) {
    return (
      <Typography variant="h6">
        {loadingInitiatePIPError?.message || `Error while loading current details for employee id : ${userId}.`}
      </Typography>
    );
  }

  const breadcrumbData = [
    { id: 1, name: 'Employee List', path: '/company/employee/employees-list', isActive: false },
    { id: 2, name: 'Employee Records', path: `/company/employee/view/${userId}`, isActive: false },
    { id: 2, name: 'Initiate PIP', isActive: true },
  ];

  return isLoadingInitiatePIP ? (
    <Box sx={{ p: 4 }}>
      <Skeleton height={70} />
      <Skeleton />
      <Skeleton />
    </Box>
  ) : (
    <BlankTemplate
      pageHeading={`Employee: ${get(initiatePIP, 'employeeInstance.fullName', '')} (${get(
        initiatePIP,
        'employeeInstance.profile.employeeId',
        'NA',
      )})`}
      breadcrumbData={breadcrumbData}
      padding="3rem"
    >
      <InitiatePIP
        employeeData={employeeData}
        handleSubmit={handleSubmit}
        loading={loading}
        label="PIP"
        btnLabel="Initiate PIP"
      />
    </BlankTemplate>
  );
};

export default InitiatePIPPage;
